import React from 'react';
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import FadeIn from 'react-fade-in';

//import FsLightbox from "fslightbox-react";
//import 'react-tabs/style/react-tabs.css';
import './tabs.css';

const ProductTabs = (props) => {

	const [items, setItems] = useState(props.items);
	const [slides, setSlides] = useState([]);
	const [productIndex, setProductIndex] = useState(0);
    //const [active, setActive] = useState(null);
	const [imageUrl] = useState([]);
	 
	useEffect(() => {		
		setSlides(items);
		setItems(items);
		const fetchData = async () => {  	
			slides.forEach(item => {
				imageUrl.push(item.image)		
			})
		}
		fetchData();	
	  
    }, [items, slides, imageUrl])
	 
	const [lightboxController, setLightboxController] = useState({
		toggler: false,
		slide: 1
	});

	function openLightboxOnSlide(number) 
	{		
		setLightboxController({
			toggler: !lightboxController.toggler,
			slide: number
		});
	}
	 
	return(
	<>	
	 {props.items.map(((item, index) => 				 	
		<FadeIn delay={70} visible={true} transitionDuration={1000} className="masonry-item cat-filter-1 col-xl-3 col-lg-6 col-md-6" key={item.id} style={{margin:'0px', padding:'0px'}}>
			<div className="flip-container">
				<div className="wt-box">
					<div className="wt-thum-bx">
						<img src={item.image} alt={item.name} onClick={() => setProductIndex(index+1)} />
					</div>
					<div className="wt-info bg-white text-center bdr-5 bdr-primary">
						<div className="wt-info-media-zoom">						
							<Link to="#" className="mfp-link0" onClick={() => openLightboxOnSlide(index+1)} ><i className="fa fa-arrows-alt font-24 p-a10"></i></Link>
						</div>
						<div className="wt-info-text p-a30">
							<h3>{item.name}</h3>
							<p>{item.description}</p>
						</div>
					 </div>
				</div>
			</div>
		</FadeIn>		
	))}
	<props.LightBox toggler={lightboxController.toggler} sources={imageUrl} slide={lightboxController.slide} key={productIndex} />		 
	</>	
    )	
}
export default ProductTabs;